import css from './numbers.module.scss';

import { memo } from 'react';

type TProps = {
  value: number;
  chosen: string;
  isAudioLoading: boolean;
};

const Tableau = ({ value, chosen, isAudioLoading }: TProps) => {
  return (
    <div className={css.tableau}>
      {isAudioLoading ? (
        '...'
      ) : (
        <>
          <span className={css.chosen}>{chosen}</span>
          <span className={css.next}>
            {String(value)
              .split('')
              .slice(chosen.length)
              .map(() => '?')}
          </span>
        </>
      )}
    </div>
  );
};

export default memo(Tableau);
